<section class="main-content">
  <div class="section-body">
    <div class="row mt-3">
      <div class="col-12">
        <div class="card card-cm-dashboard w-100">
          <div class="card-header">
            <div class="row">
              <div class="col-12">
                <h4 class="text-primary">Account Coordinator Dashboard</h4>
              </div>
            </div>
          </div>
          @if (acDashboardInfo) {
            <div class="card-body">
              <div class="row mt-3">
                <div class="col-3">
                  <div class="card w-100">
                    <div class="card-header text-secondary lh-11 primary-color">Won Orders</div>
                    <div class="card-body text-center">
                      <div>&nbsp;</div>
                      @if (acDashboardInfo.wonOrdersCount === 0) {
                        <h5 class="text-secondary">
                          {{acDashboardInfo.wonOrdersCount}}
                        </h5>
                      }
                      @if (acDashboardInfo.wonOrdersCount > 0) {
                        <h5
                          class="text-secondary primary-color cursor-pointer"
                          (click)="navigateToWONSOList()">
                          {{acDashboardInfo.wonOrdersCount}}
                        </h5>
                      }
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="card w-100">
                    <div class="card-header text-secondary lh-11 primary-color">Estimating Status</div>
                    <div class="card-body text-center">
                      <div class="row">
                        <div class="col-6">
                          <div class="primary-color">
                            With Estimator
                          </div>
                          <div>
                            @if (acDashboardInfo.withEstimatorCount === 0) {
                              <h5 class="text-secondary"
                                >
                                {{acDashboardInfo.withEstimatorCount}}
                              </h5>
                            }
                            @if (acDashboardInfo.withEstimatorCount > 0) {
                              <h5
                                class="text-secondary primary-color cursor-pointer"
                                (click)="navigateToWithEstimatorSOList()">
                                {{acDashboardInfo.withEstimatorCount}}
                              </h5>
                            }
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="primary-color">
                            Ready to Send to Client
                          </div>
                          <div>
                            @if (acDashboardInfo.readyToSentToClientCount === 0) {
                              <h5
                                class="text-secondary">
                                {{acDashboardInfo.readyToSentToClientCount}}
                              </h5>
                            }
                            @if (acDashboardInfo.readyToSentToClientCount > 0) {
                              <h5  style="display: inline-block;"
                                class="text-secondary primary-color cursor-pointer"
                                (click)="navigateToReadySOList()">
                                {{acDashboardInfo.readyToSentToClientCount}}
                              </h5>
                            }
                            @if (acDashboardInfo.readyToSentToClientCount > 0) {
                              <a  (click)="openSendRemiderToClientDialog()" class="pad-left-10 cursor-pointer warning-color text-decoration-underline">Clear</a>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-6">
                <div class="card w-100">
                  <div class="card-header text-secondary lh-11 primary-color">AC Confirmed</div>
                  <div class="card-body text-center">
                    <div class="row">
                      <div class="col-2">
                        <div class="primary-color">
                          1 day
                        </div>
                        <div>
                          <h5 class="text-secondary">
                            {{acDashboardInfo.acConfirmed1DayCount}}
                          </h5>
                        </div>
                      </div>
                      <div class="col-2">
                        <div class="primary-color">
                          2 days
                        </div>
                        <div>
                          <h5 class="text-secondary">
                            {{acDashboardInfo.acConfirmed2DayCount}}
                          </h5>
                        </div>
                      </div>
                      <div class="col-2">
                        <div class="primary-color">
                          3 days
                        </div>
                        <div>
                          <h5 class="text-secondary">
                            {{acDashboardInfo.acConfirmed3DayCount}}
                          </h5>
                        </div>
                      </div>
                      <div class="col-2">
                        <div class="primary-color">
                          1 Week
                        </div>
                        <div>
                          <h5 class="text-secondary">
                            {{acDashboardInfo.acConfirmed1WeekCount}}
                          </h5>
                        </div>
                      </div>
                      <div class="col-2">
                        <div class="primary-color">
                          2 Week
                        </div>
                        <div>
                          <h5 class="text-secondary">
                            {{acDashboardInfo.acConfirmed2WeekCount}}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="col-3">
                <div class="card w-100">
                  <div class="card-header text-secondary lh-11 primary-color">Orders with Red Flags
                  </div>
                  <div class="card-body text-center">
                    <div class="row">
                      <div class="col-4">
                        <div class="primary-color">
                          1 Week
                        </div>
                        <div>
                          @if (acDashboardInfo.ordersWithRedFlag1WeekCount > 0) {
                            <h5 class="text-secondary primary-color cursor-pointer"
                              (click)="navigateToSOList('rfw1')"
                              >
                              {{acDashboardInfo.ordersWithRedFlag1WeekCount}}
                            </h5>
                          }
                          @if (acDashboardInfo.ordersWithRedFlag1WeekCount <= 0) {
                            <h5 class="text-secondary"
                              >
                              {{acDashboardInfo.ordersWithRedFlag1WeekCount}}
                            </h5>
                          }
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="primary-color">
                          2 Weeks
                        </div>
                        <div>
                          @if (acDashboardInfo.ordersWithRedFlag2WeeksCount > 0) {
                            <h5 class="text-secondary primary-color cursor-pointer"
                              (click)="navigateToSOList('rfw2')"
                              >
                              {{acDashboardInfo.ordersWithRedFlag2WeeksCount}}
                            </h5>
                          }
                          @if (acDashboardInfo.ordersWithRedFlag2WeeksCount <= 0) {
                            <h5 class="text-secondary"
                              >
                              {{acDashboardInfo.ordersWithRedFlag2WeeksCount}}
                            </h5>
                          }
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="primary-color">
                          4 Weeks
                        </div>
                        <div>
                          @if (acDashboardInfo.ordersWithRedFlag4WeeksCount > 0) {
                            <h5 class="text-secondary primary-color cursor-pointer"
                              (click)="navigateToSOList('rfw4')"
                              >
                              {{acDashboardInfo.ordersWithRedFlag4WeeksCount}}
                            </h5>
                          }
                          @if (acDashboardInfo.ordersWithRedFlag4WeeksCount <= 0) {
                            <h5 class="text-secondary"
                              >
                              {{acDashboardInfo.ordersWithRedFlag4WeeksCount}}
                            </h5>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="card w-100">
                  <div class="card-header text-secondary lh-11 primary-color">Orders with No Labor
                  Calls</div>
                  <div class="card-body text-center">
                    <div class="row">
                      <div class="col-4">
                        <div class="primary-color">
                          2 Week
                        </div>
                        <div>
                          @if (acDashboardInfo.ordersWithNoLabor2WeeksCount > 0) {
                            <h5 class="text-secondary primary-color cursor-pointer"
                              (click)="navigateToSOList('nlbrw2')"
                              >
                              {{acDashboardInfo.ordersWithNoLabor2WeeksCount}}
                            </h5>
                          }
                          @if (acDashboardInfo.ordersWithNoLabor2WeeksCount <= 0) {
                            <h5 class="text-secondary"
                              >
                              {{acDashboardInfo.ordersWithNoLabor2WeeksCount}}
                            </h5>
                          }
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="primary-color">
                          4 Weeks
                        </div>
                        <div>
                          @if (acDashboardInfo.ordersWithNoLabor4WeeksCount > 0) {
                            <h5 class="text-secondary primary-color cursor-pointer"
                              (click)="navigateToSOList('nlbrw4')"
                              >
                              {{acDashboardInfo.ordersWithNoLabor4WeeksCount}}
                            </h5>
                          }
                          @if (acDashboardInfo.ordersWithNoLabor4WeeksCount <= 0) {
                            <h5 class="text-secondary"
                              >
                              {{acDashboardInfo.ordersWithNoLabor4WeeksCount}}
                            </h5>
                          }
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="primary-color">
                          8 Weeks
                        </div>
                        <div>
                          @if (acDashboardInfo.ordersWithNoLabor8WeekCount > 0) {
                            <h5 class="text-secondary primary-color cursor-pointer"
                              (click)="navigateToSOList('nlbrw8')"
                              >
                              {{acDashboardInfo.ordersWithNoLabor8WeekCount}}
                            </h5>
                          }
                          @if (acDashboardInfo.ordersWithNoLabor8WeekCount <= 0) {
                            <h5 class="text-secondary"
                              >
                              {{acDashboardInfo.ordersWithNoLabor8WeekCount}}
                            </h5>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
</section>

<ng-template [tuiDialogOptions]="{ closable: false, size: 'm', dismissible: false}" [(tuiDialog)]="isReadyToSentToClientClearDialog">
  <tui-loader class="loader" [inheritColor]="isLoadingReadyToSentToClientClear" [overlay]="isLoadingReadyToSentToClientClear"
    [loading]="isLoadingReadyToSentToClientClear">
    <header class="header">
      <div class="col-12">
        <div class="title-flex">
          <h4 class="main-title">
            <span tuiAvatar="@tui.credit-card"  class="taga-icons"></span>
            <span class="mt-1 pad-left-10">Ready to Sent to Client Clear - Confirmation</span>
          </h4>
          <div class="text-end-container">
            <button iconStart="@tui.x" class="margin-left-10" appearance="outline" tuiIconButton
            (click)="closeSendRemiderToClientDialog()" type="button" size="s" placement="right"></button>
          </div>
        </div>
      </div>
    </header>
    <div class="dialog-content">
      <hr class="title-line mt-1 mb-2">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <p class="text-center primary-color">
            <strong>Are you sure you want to Clear Ready to Sent to Client?</strong>
          </p>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
          <button appearance="primary" tuiButton size="s" type="button" class="tui-space_bottom-3"
            (click)="soReadyToSentToClientClear()">Yes
          </button>
        </div>
      </div>
    </div>
  </tui-loader>
</ng-template>